import { Button } from '@/components/shared/basic'
import Modal from '../../Modal/Modal'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'
import { getWhatsAppUrl } from 'src/constants/whatsapp'
import { segmentTrackCallback } from '@/utils/segment'
import { SegmentEventType } from '@qureos/types'

interface Props {
  title: string
  message: string
  visible: boolean
  onCancel: () => void
}

const CandidateJobApplicationThankYouModal = ({
  title,
  message,
  visible,
  onCancel
}: Props) => {
  const { t: Labels } = useTranslation('common')

  const getJobsNowButton = (
    <div className="w-full w-max mt-2">
      <Button
        onClick={() => {
          segmentTrackCallback(SegmentEventType.GET_JOBS_NOW_CLICKED)
          window.open(getWhatsAppUrl(), '_blank')
        }}
        theme="normal"
        rounded="normal"
        className="hover:bg-blue-500 hover:shadow-md"
      >
        {Labels('WA_IRIS_BUTTON')}
      </Button>
    </div>
  )

  return (
    <Modal onCancel={onCancel} visible={visible} footer={false}>
      <div className="w-full flex flex-col items-center justify-center">
        <CheckCircleIcon className="w-20 h-20 text-blue-500" />
        <p className="text-lg font-medium mt-4">{title}</p>
        <p className="text-md text-gray-500 max-w-[600px] px-6 text-center">
          {message}
        </p>
      </div>
      <div className="w-full border-t my-8"></div>
      <div className="bg-blue-100 p-4 rounded-md mt-4">
        <div className="w-full flex justify-between">
          <div className="flex-1 flex flex-col gap-2">
            <p className="text-lg font-medium">{Labels('WA_IRIS_TITLE')}</p>
            <p className="max-w-[280px] text-gray-500">
              {Labels('WA_IRIS_DESCRIPTION')}
            </p>
            <div className="invisible md:visible">{getJobsNowButton}</div>
          </div>
          <img
            className="h-[160px]"
            src="https://storage.googleapis.com/qureos-prod/static/banners/iris-wa-svg.svg"
            alt="Illustration of a conversation representing successful job application submission"
          />
        </div>
        <div className="visible md:hidden w-full flex justify-center">
          {getJobsNowButton}
        </div>
      </div>
    </Modal>
  )
}

export default CandidateJobApplicationThankYouModal
